// Auto-generated normalizer for table: PropiedadesContenido
export function propiedadesContenidoNormalize(row) {
  return {
    idPropiedadContenido: row.idPropiedadContenido ?? row.IdPropiedadContenido ?? row['IdPropiedadContenido'] ?? 0,
    idContenido: row.idContenido ?? row.IdContenido ?? row['IdContenido'] ?? 0,
    idPropiedad: row.idPropiedad ?? row.IdPropiedad ?? row['IdPropiedad'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
